import React, { useEffect } from 'react';

interface IProps {
    thankYouProps: {
        recipientName: string;
        partnerName: string;
        thankYouMessage?: string;
    },
    ctaThankYouLink: string;
};

const ThankYou: React.FC<IProps> = ({ thankYouProps, ctaThankYouLink }) => {
    const {
        recipientName,
        partnerName,
        thankYouMessage,
    } = thankYouProps;


    return (
        <article className="c-contributionThankYou">
            <section className="c-contributionThankYou__content">
                <h3 className="c-contributionThankYou__title">Thank you</h3>
                <p>
                    Your contribution has been sent. We’ll notify {recipientName} and {partnerName} right away. If you’re interested in where it might be spent, check out our seductive collections.
                </p>
                {thankYouMessage &&
                    <p className="c-contributeIntro__content">
                        <q>{thankYouMessage}</q>
                    </p>
                }
                <a href={ctaThankYouLink}>
                    <button className="c-contributionThankYou__cta">See collections</button>
                </a>
            </section>
        </article>
    );
};

export default ThankYou;
